import React from "react";

export default function renderIcon({
  width = 21,
  height = 21,
  color = "#9ca2b8",
}) {
  return (
    <svg
      width="17"
      height="19"
      viewBox="0 0 17 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6667 10.6205V7.33333C14.6667 4.38442 12.6637 1.90025 9.95042 1.15317C9.68183 0.476667 9.0255 0 8.25 0C7.4745 0 6.81817 0.476667 6.54958 1.15317C3.83625 1.90117 1.83333 4.38442 1.83333 7.33333V10.6205L0.268583 12.1852C0.0966631 12.3571 5.19176e-05 12.5902 0 12.8333V14.6667C0 14.9098 0.0965771 15.1429 0.268485 15.3148C0.440394 15.4868 0.673552 15.5833 0.916667 15.5833H15.5833C15.8264 15.5833 16.0596 15.4868 16.2315 15.3148C16.4034 15.1429 16.5 14.9098 16.5 14.6667V12.8333C16.4999 12.5902 16.4033 12.3571 16.2314 12.1852L14.6667 10.6205ZM14.6667 13.75H1.83333V13.2128L3.39808 11.6481C3.57 11.4762 3.66661 11.2431 3.66667 11V7.33333C3.66667 4.80608 5.72275 2.75 8.25 2.75C10.7773 2.75 12.8333 4.80608 12.8333 7.33333V11C12.8333 11.2438 12.9296 11.4767 13.1019 11.6481L14.6667 13.2128V13.75ZM8.25 18.3333C8.81769 18.334 9.3715 18.1579 9.83445 17.8293C10.2974 17.5007 10.6465 17.0361 10.8332 16.5H5.66683C5.85352 17.0361 6.2026 17.5007 6.66555 17.8293C7.1285 18.1579 7.68231 18.334 8.25 18.3333Z"
        fill="#4B247E"
      />
    </svg>
  );
}
